import { render, staticRenderFns } from "./DecoContestResultPage.vue?vue&type=template&id=5a0eb255&"
import script from "./DecoContestResultPage.vue?vue&type=script&lang=ts&"
export * from "./DecoContestResultPage.vue?vue&type=script&lang=ts&"
import style0 from "./DecoContestResultPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports